var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6562 4V6.4375M8.34375 4V6.4375M12 4V6.4375",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 5.21875H11.1875C8.50639 5.21875 7.16583 5.21875 6.33292 6.05167C5.5 6.88458 5.5 8.22514 5.5 10.9062V14.5625C5.5 17.2436 5.5 18.5841 6.33292 19.4171C7.16583 20.25 8.50639 20.25 11.1875 20.25H12.8125C15.4936 20.25 16.8341 20.25 17.6671 19.4171C18.5 18.5841 18.5 17.2436 18.5 14.5625V10.9062C18.5 8.22514 18.5 6.88458 17.6671 6.05166C16.8341 5.21875 15.4936 5.21875 12.8125 5.21875Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14.5625H12M8.75 11.3125H15.25",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOrder);
export default __webpack_public_path__ + "static/media/workOrder.4620eb0c14e10e90c3b16c89a13b1420.svg";
export { ForwardRef as ReactComponent };